import React, { FC } from "react";
import { Dialog, DialogProps, IconButton, styled } from "@mui/material";
import Modal from "components/Modal";
import { Close } from "@mui/icons-material";

interface BadgeModalProps extends DialogProps {

  onhandleClose: () => void;
}

const BadgeModal: FC<BadgeModalProps> = ({ onhandleClose, children, ...rest }) => {

  return (
    <CustomModal disableEscapeKeyDown {...rest}>
      <CloseIconButton onClick={onhandleClose}>
        <Close />
      </CloseIconButton>
      {children}
    </CustomModal>
  );
};

export default BadgeModal;

const CustomModal = styled(Dialog)({
  "&&": {
    borderRadius: 6,
    "@media (min-width: 768px)": {
      ".MuiDialog-paper": {
        height: 'auto',
        maxWidth: 375,
        borderRadius: 10,
      },
    }
  }
});

const CloseIconButton = styled(IconButton)({
  position: 'absolute',
  top: 4,
  right: 4,
  zIndex: 99
})
